import * as React from 'react'
import CategoryRecommendItem from '../../../Home/components/HomeItemListItem/HomeItemListItem'
import WKInfiniteScroll from '@/components/WKInfiniteScroll/WKInfiniteScroll'
import HomeType from '../../../Home/types/HomeType'
import * as Styles from './CategoryRecommend.style'
import {HttpServer} from '@/services/server'
import { getJsonFromUrl } from '@/utils/tools'

interface CategoryTypeProps {
    content: {
        has_more: boolean,
        ret: HomeType.Content[]
    },
    categoryId: number,
    isChangeType: boolean
}

interface CategoryTypeState {
    recommendData: HomeType.Content[],
    has_more: boolean,
    loading: boolean,
    pageNum: number
}

export default class CategoryRecommend extends React.Component <CategoryTypeProps, CategoryTypeState> {
    public state = {
        recommendData: [],
        has_more: true,
        loading: false,
        pageNum: 1
    }
    public componentDidMount() {
        this.setState({
          recommendData: this.props.content.ret,
          has_more: this.props.content.has_more,
          loading: false
        })
    }
    public componentWillReceiveProps(nextProps: any) {
        if (nextProps.content) {
            this.setState({
                recommendData: nextProps.content.ret,
                has_more:  nextProps.content.has_more,
                loading: false
            })
        }
    }
    public loadMoreInfo = () => {
        if (this.props.isChangeType) {
           this.setState({
               pageNum: 1
           })
           return
        }
        this.setState({
            loading: true
        })

        const params = {
            category: getJsonFromUrl().id || this.props.categoryId,
            p: ++this.state.pageNum
        }
        HttpServer.getCategoryRecommendData(params).then((res) => {
            if (res.data.code === 0) {
                this.setState({
                  recommendData: this.state.recommendData.concat(res.data.data.ret),
                  has_more: res.data.data.has_more,
                  loading: false
                })
              }
        })
    }

    public render() {
        return (
                <div className="CategoryRecommend">
                    <div className={Styles.titleName} style={{marginTop: 30}}>更多推荐</div>
                    {this.state.recommendData.map((v: HomeType.Content, index) => (
                        <CategoryRecommendItem content={v} key={index}/>
                    ))}
                    <div>
                        <WKInfiniteScroll
                            onTouchBottom={this.loadMoreInfo} // 到达底部执行的方法
                            isStop={this.state.loading} // 暂停执行onTouchBottom，一般是正在请求接口时触发
                            distance={200} // 距离底部多少px触发
                            isKill={!this.state.has_more} // 不再监听滚动，一般是传!has_more
                            isShowLoading={true} // 请求数据的时候（isStop）是否显示菊花
                        />
                    </div>
                </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/Category/components/CategoryRecommend/CategoryRecommend.tsx